import type { City } from "@/types/common";

export type CsspCity = {
  name: string;
  code: string;
};

const supportedCities: CsspCity[] = [
  { name: "Кемерово", code: "kemerovo" },
  { name: "Новосибирск", code: "novosibirsk" },
];

export const normalizeCsspCityName = (value: string) => value.trim().toLocaleLowerCase("ru-RU");

export const getCsspCity = (city: string): CsspCity | null => {
  const normalized = normalizeCsspCityName(city);
  return supportedCities.find((candidate) => normalizeCsspCityName(candidate.name) === normalized) ?? null;
};

export type ResolvedCsspCity = CsspCity & { id: string };

/** Resolve only an unambiguous, non-empty directory id. Never infer it from a name. */
export const resolveCsspCity = (city: string, cities: City[]): ResolvedCsspCity | null => {
  const supported = getCsspCity(city);
  if (!supported) return null;

  const matches = cities.filter((candidate) =>
    normalizeCsspCityName(String(candidate.name ?? "")) === normalizeCsspCityName(supported.name)
  );
  if (matches.length !== 1) return null;

  const id = String(matches[0].id ?? "").trim();
  return id ? { ...supported, id } : null;
};
